import { IStandardAutocomplete } from "../../_common/interface/autocomplete/iStandardAutocomplete";
import { IStandardMultipleAutocomplete } from "../../_common/interface/autocomplete/iStandardMultipleAutocomplete";
import { formFieldKeyService } from "../../_services/formFieldKey.service";
import { formFieldKeyLookupService } from "../../_services/formFieldKeyLookup.service";
import { MultipleAutoComplete } from "./multiple.autocomplete";
import StandardAutoComplete from "./standard.autocomplete";

interface IStandardExtAutocomplete extends IStandardAutocomplete {
}

export const FormFieldKeySectionAutoComplete = (params: IStandardExtAutocomplete) => {

    return (
        <StandardAutoComplete
            {...params}
            itemsLoader={() => { return formFieldKeyService.dropdownSections(Number(params.parentId)) }}
            label={"Form Field Key Section Select"} />
    );
}